if (!customElements.get('skin-concern-selector')) {
  class SkinConcernSelector extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('[data-skin-concern-item]'));
      this.panels = Array.from(this.querySelectorAll('[data-skin-concern-panel]'));

      if (!this.items.length || !this.panels.length) return;

      this.items.forEach((item, index) => {
        item.tabIndex = item.classList.contains('is-active') ? 0 : -1;
        item.addEventListener('mouseenter', () => this.activate(item));
        item.addEventListener('focus', () => this.activate(item));
        item.addEventListener('click', () => this.activate(item));
        item.addEventListener('keydown', (event) => this.onKeydown(event, index));
      });
    }

    onKeydown(event, index) {
      const isHorizontal = event.key === 'ArrowRight' || event.key === 'ArrowLeft';
      const isVertical = event.key === 'ArrowDown' || event.key === 'ArrowUp';
      if (!isHorizontal && !isVertical) return;

      event.preventDefault();
      const direction = event.key === 'ArrowRight' || event.key === 'ArrowDown' ? 1 : -1;
      const nextIndex = (index + direction + this.items.length) % this.items.length;
      const nextItem = this.items[nextIndex];

      nextItem.focus();
      this.activate(nextItem);
    }

    activate(item) {
      if (item.classList.contains('is-active')) return;
      const index = item.dataset.index;

      this.items.forEach((el) => {
        const isActive = el === item;
        el.classList.toggle('is-active', isActive);
        el.setAttribute('aria-selected', isActive ? 'true' : 'false');
        el.tabIndex = isActive ? 0 : -1;
      });

      this.panels.forEach((panel) => {
        const isActive = panel.dataset.index === index;
        panel.classList.toggle('is-active', isActive);
        panel.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      });
    }
  }

  customElements.define('skin-concern-selector', SkinConcernSelector);
}
